import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = { class: "row full-width" }
const _hoisted_3 = { class: "row row full-width" }
const _hoisted_4 = { class: "row q-pa-md" }
const _hoisted_5 = { class: "q-ml-sm" }
const _hoisted_6 = { class: "text-h6" }
const _hoisted_7 = ["onClick"]

import { showErrorMsgToast, showSuccessMsgToast } from '@/common';
import {
  CandidateTagCreateAssignGroupRequest,
  FilterResponseDto,
  GroupCandidateTagDto,
  TagMangementDto,
  User
} from '@/store/models';
import interviewRecruiterModule from '@/store/modules/interviewRecruiterModule';
import userModule from '@/store/modules/userModule';
import { findIndex } from 'lodash-es';
import LoadingIndicator from './LoadingIndicator.vue';

import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsManagement',
  props: ['loadTags'],
  emits: ['refresh-candidate-tags'],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, locale } = useI18n();

const loadTags = __props;

const candidateTagOptions = ref<GroupCandidateTagDto[]>([]);
const filteredTagOptions = ref<GroupCandidateTagDto[]>([]);
const copyTagOptions = ref<GroupCandidateTagDto[]>([]);
const tagsFilterSearch = ref<string>('');
const showAddTag = ref<boolean>(false);
const disableAddTag = ref<boolean>(false);
const newTagValue = ref<string>('');
const showLoadingIndicator = ref<boolean>(false);
const showTagDeleteConfirmation = ref<boolean>(false);
const selectedTagToDelete = ref<TagMangementDto | null>(null);
const showAddGroupsDialog = ref<boolean>(false);
const groupFiltersearch = ref<string>('');
const userGroups = ref<FilterResponseDto[]>([]);
const filteredGroups = ref<FilterResponseDto[]>([]);
//const selectedGroupSlug = ref<number | null>(null);
const loggedInUser = ref<User | null>(null);
const isApplyButtonDisabled = ref<boolean>(false);

const emit = __emit;

// Watchers using the watch function
// eslint-disable-next-line @typescript-eslint/no-empty-function
watch(
  loadTags,
  (newValue, oldValue) => {
    loadCandidateTags();
  },
  { immediate: true }
);

async function loadCandidateTags() {
  try {
    loggedInUser.value = userModule.loggedInUser;
    candidateTagOptions.value = [];
    candidateTagOptions.value =
      await interviewRecruiterModule.dogetCandidateTagsWithGroup();
    copyTagOptions.value = JSON.parse(
      JSON.stringify(candidateTagOptions.value)
    );
    //if Admin retrieving group in tenant level else retrieving in user level
    if (isAdmin()) {
      await getTenantGroups();
    } else {
      await getUserGroups();
    }
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
}

function onTagsFilterSearchChange() {
  if (tagsFilterSearch.value) {
    filteredTagOptions.value = copyTagOptions.value
      .map(group => {
        const matchingTags = group.candidateTagDtos.filter(tag =>
          tag.label.toLowerCase().match(tagsFilterSearch.value.toLowerCase())
        );
        return {
          ...group,
          candidateTagDtos: matchingTags
        };
      })
      .filter(group => group.candidateTagDtos.length > 0);
  } else {
    filteredTagOptions.value = copyTagOptions.value;
  }
  candidateTagOptions.value = filteredTagOptions.value;
}

const tagValueChanged = (tag: TagMangementDto) => {
  candidateTagOptions.value.forEach(e => {
    if (e.value === tag.value) {
      e.disableSave = false;
    }
  });
};

const createNewTag = async () => {
  try {
    showLoadingIndicator.value = true;
    let newTagDto: CandidateTagCreateAssignGroupRequest = {
      newTagName: newTagValue.value,
      groupSlugs: []
    };

    for (let index = 0; index < userGroups.value.length; index++) {
      const element = userGroups.value[index];
      if (element.selected) {
        newTagDto.groupSlugs.push(element.id);
      }
    }

    /*if (isAdmin() && selectedGroupSlug.value != null) {
        newTagDto.groupSlug = selectedGroupSlug.value;
      }*/
    await interviewRecruiterModule.doCreateCandidateTagAssignGroup(newTagDto);
    await loadCandidateTags();
    showAddTag.value = false;
    disableAddTag.value = false;
    //selectedGroupSlug.value  = null;
    showLoadingIndicator.value = false;
    emit('refresh-candidate-tags', {});
    showSuccessMsgToast(t('message.newTagCeatedMsgToast') as string);
    //clear tag entered after save
    newTagValue.value = '';
  } catch (error) {
    showLoadingIndicator.value = false;
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
};

const updateTagName = async (tag: TagMangementDto) => {
  try {
    await interviewRecruiterModule.doUpdateCandidateTagName(tag);
    candidateTagOptions.value.forEach(e => {
      if (e.value === tag.value) {
        e.disableSave = true;
      }
    });
    emit('refresh-candidate-tags', {});
    showSuccessMsgToast(t('message.changesSavedText') as string);
  } catch (error) {
    showLoadingIndicator.value = false;
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
};

const deleteTagName = async () => {
  try {
    if (selectedTagToDelete.value) {
      await interviewRecruiterModule.doDeleteCandidateTagName(
        selectedTagToDelete.value
      );
      await loadCandidateTags();
      selectedTagToDelete.value = null;
      showTagDeleteConfirmation.value = false;
      emit('refresh-candidate-tags', {});
      showSuccessMsgToast(t('message.tagDeletedMsgToast') as string);
    }
  } catch (error) {
    showLoadingIndicator.value = false;
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
};

const getTenantGroups = async () => {
  const response = await interviewRecruiterModule.doGetTenantGroups();
  userGroups.value = response;
  filteredGroups.value = userGroups.value;
};

const getUserGroups = async () => {
  const response = await interviewRecruiterModule.doGetUserGroups();
  userGroups.value = response;
  filteredGroups.value = userGroups.value;
};

const onGroupFilterSearchChange = () => {
  userGroups.value = filteredGroups.value.filter(x =>
    x.itemName.toLowerCase().match(groupFiltersearch.value.toLowerCase())
  );
};

const onClickUserGroup = (group: FilterResponseDto) => {
  group.selected = !group.selected;
  selectUserGroup(group);
};

//Below method modified to enable multiple selection of Group
const selectUserGroup = (group: FilterResponseDto) => {
  const selectableUserGroupIndex: number = findIndex(
    userGroups.value,
    function (t) {
      return t.id == group.id;
    }
  );

  if (selectableUserGroupIndex !== -1) {
    userGroups.value[selectableUserGroupIndex].selected = group.selected;
  }
  if (isSelectedGroup()) {
    isApplyButtonDisabled.value = false;
  } else {
    isApplyButtonDisabled.value = true;
  }
};

const isAdmin = () => {
  if (loggedInUser.value != null) {
    if (loggedInUser.value.roleLevel.toString() === 'SUPERADMIN') {
      return true;
    } else if (loggedInUser.value.roleLevel.toString() === 'ADMIN') {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

const disableSave = () => {
  // if (isAdmin()) {
  return newTagValue.value.length < 2 || !isSelectedGroup();
  // } else {
  //   return newTagValue.value.length < 2;
  // }
};

const isSelectedGroup = () => {
  //returns true if atleastone group selected
  return userGroups.value.some(item => item.selected);
};

const deselectGroup = () => {
  for (let index = 0; index < userGroups.value.length; index++) {
    const element = userGroups.value[index];
    if (element.selected) {
      userGroups.value[index].selected = false;
    }
  }
};

const getGroupTitle = (group: GroupCandidateTagDto) => {
  return group.groupName + ' (' + group.candidateTagDtos.length + ')';
};

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, { style: {"min-width":"45vw","max-width":"80vw"} }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "row items-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('message.manageTagsLbl')), 1),
          _createVNode(_component_q_space),
          _withDirectives(_createVNode(_component_q_btn, {
            icon: "close",
            flat: "",
            round: "",
            dense: ""
          }, null, 512), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            dense: "",
            filled: "",
            color: "primary",
            modelValue: tagsFilterSearch.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((tagsFilterSearch).value = $event)),
              onTagsFilterSearchChange
            ],
            label: _ctx.$t('message.reportsFilterSearchLbl')
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {
              tagsFilterSearch.value = '';
              onTagsFilterSearchChange();
            }),
                class: "cursor-pointer"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "label"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, {
        style: {"height":"43vh"},
        class: "scroll"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidateTagOptions.value, (candidateTagOption) => {
              return (_openBlock(), _createElementBlock("div", {
                key: candidateTagOption.groupName
              }, [
                _createVNode(_component_q_expansion_item, {
                  "expand-separator": "",
                  icon: "group",
                  label: getGroupTitle(candidateTagOption),
                  "header-class": "text-bold text-primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidateTagOption.candidateTagDtos, (tag) => {
                                  return (_openBlock(), _createBlock(_component_q_item, {
                                    key: tag.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_2, [
                                            _createVNode(_component_q_input, {
                                              modelValue: tag.label,
                                              "onUpdate:modelValue": [($event: any) => ((tag.label) = $event), ($event: any) => (tagValueChanged(tag))],
                                              dense: "",
                                              outlined: "",
                                              style: {"min-width":"30vw"}
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                            _createVNode(_component_q_btn, {
                                              icon: "save",
                                              color: "primary",
                                              class: "q-mr-md",
                                              flat: "",
                                              disabled: tag.disableSave,
                                              onClick: ($event: any) => (updateTagName(tag))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_tooltip, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('message.updateContactLbl')), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled", "onClick"]),
                                            _createVNode(_component_q_btn, {
                                              icon: "delete",
                                              color: "primary",
                                              class: "q-mr-md",
                                              flat: "",
                                              onClick: ($event: any) => {
                            showTagDeleteConfirmation.value = true;
                            selectedTagToDelete.value = tag;
                          }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_tooltip, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('message.deleteLbl')), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["label"]),
                _createVNode(_component_q_separator)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_input, {
            modelValue: newTagValue.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newTagValue).value = $event)),
            dense: "",
            outlined: "",
            label: "New Tag",
            style: {"min-width":"25vw"}
          }, null, 8, ["modelValue"]),
          _createVNode(_component_q_btn, {
            icon: "group_add",
            color: "primary",
            flat: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (
            (showAddGroupsDialog.value = true),
              (isApplyButtonDisabled.value = !isSelectedGroup())
          ))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.selectGroupTooltip')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_btn, {
            icon: "save",
            color: "primary",
            flat: "",
            disabled: disableSave(),
            onClick: createNewTag
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.saveLbl')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_q_btn, {
            icon: "cancel",
            color: "primary",
            flat: "",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {
            showAddTag.value = false;
            disableAddTag.value = false;
            newTagValue.value = '';
          })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.cancelLbl')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, showAddTag.value]
        ]),
        _createVNode(_component_q_space),
        _createVNode(_component_q_card_actions, {
          align: "right",
          class: "q-pa-md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "add",
              label: _ctx.$t('message.addCandidateTagButtonLbl'),
              color: "primary",
              disabled: disableAddTag.value,
              onClick: _cache[5] || (_cache[5] = ($event: any) => {
            showAddTag.value = true;
            disableAddTag.value = true;
          })
            }, null, 8, ["label", "disabled"])
          ]),
          _: 1
        })
      ]),
      _createVNode(LoadingIndicator, { showLoading: showLoadingIndicator.value }, null, 8, ["showLoading"]),
      _createVNode(_component_q_dialog, {
        modelValue: showTagDeleteConfirmation.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showTagDeleteConfirmation).value = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { style: {"min-width":"40vw"} }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "row items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, {
                    icon: "delete_forever",
                    color: "negative",
                    "text-color": "white"
                  }),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('message.tagDeleteConfirmationMsg')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { align: "right" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    flat: "",
                    label: _ctx.$t('message.deleteConfirmationNoBtnLbl'),
                    color: "primary"
                  }, null, 8, ["label"]), [
                    [_directive_close_popup]
                  ]),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    label: _ctx.$t('message.deleteConfirmationYesBtnLbl'),
                    color: "primary",
                    onClick: _withModifiers(deleteTagName, ["prevent"])
                  }, null, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_dialog, {
        modelValue: showAddGroupsDialog.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showAddGroupsDialog).value = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { style: {"min-width":"40vw","max-width":"80vw"} }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "row items-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('message.selectGroupTooltip')), 1),
                  _createVNode(_component_q_space),
                  _withDirectives(_createVNode(_component_q_btn, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_section, {
                style: {"max-height":"40vh"},
                class: "scroll"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    class: "q-pb-lg",
                    dense: "",
                    filled: "",
                    color: "primary",
                    modelValue: groupFiltersearch.value,
                    "onUpdate:modelValue": [
                      _cache[8] || (_cache[8] = ($event: any) => ((groupFiltersearch).value = $event)),
                      onGroupFilterSearchChange
                    ],
                    label: _ctx.$t('message.reportsFilterSearchLbl')
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "close",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                  groupFiltersearch.value = '';
                  onGroupFilterSearchChange();
                }),
                        class: "cursor-pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"]),
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userGroups.value, (group) => {
                        return (_openBlock(), _createBlock(_component_q_item, {
                          key: group.id,
                          clickable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "row full-width items-center",
                                  onClick: _withModifiers(($event: any) => (onClickUserGroup(group)), ["prevent"])
                                }, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_q_checkbox, {
                                      modelValue: group.selected,
                                      "onUpdate:modelValue": [($event: any) => ((group.selected) = $event), ($event: any) => (selectUserGroup(group))]
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_q_item_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(group.itemName), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ], 8, _hoisted_7)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { align: "right" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    "no-caps": "",
                    onClick: deselectGroup,
                    color: "primary",
                    icon: "cancel",
                    label: _ctx.$t('message.cancelLbl')
                  }, null, 8, ["label"]), [
                    [_directive_close_popup]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    "no-caps": "",
                    class: "text-white",
                    color: "primary",
                    disabled: isApplyButtonDisabled.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.apply')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})